import React, { useState,useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash,faSpinner  } from "@fortawesome/free-solid-svg-icons";
import { setToken } from "../auth";
import  login  from "../funzioni_server/login_function.js";
import "./Login.css"; // Stile CSS
function Login() {
    const [username, setUsername]=useState("")
    const [password, setPassword]=useState("")
    const [showPassword,setShowPassword]=useState(false)
    const [loading,setLoading]=useState(false)
    const handleLogin = async () =>{
    setLoading(true);
    const response = await login({"username":username, "password":password});
    setLoading(false)

};


    return (
        <div className="background-container">
  <video autoPlay loop muted playsInline className="background-video">
    <source src="/sfondo.mp4" type="video/mp4" />
    Il tuo browser non supporta il video.
  </video>

            <div className="container">
                <div className="logo-wrapper">
                    <img src="/logo.png" alt="Logo" className="logo"/>
                </div>

                <h1 className="titoloLog">Benvenuto nel sistema gestionale JC Kite School</h1>
                <div className="middle-wrapper">
                    <div className="login-container">
                        <h2>Login</h2>
                        <div className="input-wrapper">
                            <input type="text" placeholder="Username" value={username}
                                   onChange={(e) => setUsername(e.target.value)}/>
                        </div>
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleLogin();
                                }}
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                className="eye-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                        {loading ? (
                            <FontAwesomeIcon icon={faSpinner} spin className="loading-spinner"/>
                        ) : (
                            <button className="login" onClick={handleLogin}>Login</button>
                        )}
                    </div>
                </div>
                </div>
            </div>

            );

            }
            export default Login